sharpen-choice-grid {
  display: grid;
  gap: 1em;
  grid-template-columns: repeat(2, 1fr);
  font-weight: bold;
  font-size: 18pt;
  text-align: center;

  input { display: none; }

  &[layout="column"] {
    display: flex;
    flex-direction: column;
    text-align: left;
    font-weight: normal;
    font-size: 24pt;
  }

  a, label { 
    color: var(--color-pine);
    cursor: pointer;
    --animate-duration: 1.5s;
    text-decoration: none;

    img {
      max-width: 100%;
    }

    &.highlight sharpen-card, &:hover sharpen-card {
      background-color: var(--color-sky);
    }
  }
}

// In the Storymaker case, we don't want the choice images to be too high
// that the options need to scroll
.storymaker sharpen-choice-grid a img {
  max-height: 10rem;
}